import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Estimativa } from 'src/app/models/estimativa.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { AnexoService } from 'src/app/services/anexo.service';
import { ComentarioService } from 'src/app/services/comentario.service';
import { UtilService } from 'src/app/services/util.service';
import { Comentario } from 'src/app/models/comentario.model';

@Component({
    selector: 'app-estimativa-aprovar-form-component',
    templateUrl: './estimativa-aprovar-form.component.html',
    styleUrls: ['./estimativa-aprovar-form.component.scss']
})

export class EstimativaAprovarFormComponent implements OnInit {

    basicForm: UntypedFormGroup;
    selectedFile: File = null;
    estimativa: Estimativa;
    byPassAprovacao: boolean = false;
    textoAprovar: string = "Enviar Proposta";

    constructor(
        public dialogRef: MatDialogRef<EstimativaAprovarFormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,
        private estimativaService: EstimativaService,
        private anexoService: AnexoService,
        private router: Router,
        private comentarioService: ComentarioService,
        public utilService: UtilService,
        private toastr: ToastrComponent) {
        this.createForm();
    }

    ngOnInit() {
        this.byPassAprovacao = this.data.byPassAprovacao;
       

        if(this.byPassAprovacao)
            this.textoAprovar = "Aprovar Proposta";
        this.estimativaService.getById(this.data.estimativaId).subscribe(estimativa => {
            this.estimativa = estimativa;
        });
    }

    createForm() {
        this.basicForm = this.fb.group({
            arquivo: new UntypedFormControl(null),
            mensagem: ['']
        });
    }

    onSelectFile(fileInput: any) {
        this.selectedFile = fileInput.target.files[0] as File;
    }

    save() {
    // Onde faz a confirmação.
        let file: string[];

        if (this.selectedFile) {
            file = this.selectedFile.name.split('.');

            if (file[1] !== 'ppt' && file[1] !== 'pptx') {
                this.toastr.mostrarMensagem('aviso', 'Atenção', 'Formato de arquivo inválido: ' + file[1]);
                return;
            }
        }

        if (this.basicForm.value.mensagem.length > 500) {
            this.toastr.mostrarMensagem('aviso', 'Atenção', 'Comentário excede o máximo de caracteres permitido: 500');
            return;
        }

        if(!this.byPassAprovacao)
            this.estimativa.statusId = 4;

        this.estimativaService.update(this.estimativa).subscribe(() => {
            if (this.selectedFile) {
                const formData = new FormData();
                formData.append('Arquivo', this.selectedFile);
                formData.append('EstimativaId', this.data.estimativaId);
                formData.append('Tipo', 'PPT');

                this.anexoService.upload(formData).subscribe();
            }

            if (this.basicForm.value.mensagem !== '') {
                const comentario = new Comentario();
                comentario.estimativaId = this.data.estimativaId;
                comentario.mensagem = this.basicForm.value.mensagem;
                comentario.usuarioId = this.utilService.getUserId();
                comentario.ativo = true;

                this.comentarioService.create(comentario).subscribe();
            }

            if(!this.byPassAprovacao) {
                this.dialogRef.close();
                this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Estimativa enviada com sucesso');
                this.router.navigate(['price/projeto/estimativa-list/' + this.data.projetoId]);
            } else {
                this.dialogRef.close({
                    byPassAprovacao: this.byPassAprovacao
                });
            }

        }, () => {
            this.toastr.mostrarMensagem('erro', 'Erro', 'Erro ao incluir o registro');
        });
    }
}
